<template>
  <SimpleDataTable
      :clickable-title="true"
      :title="'Müşteri Senetleri'"
      :description="''"
      :dataList="chequeSumReportData"
      :dataHeaders="chequeSumReportHeaders"
      :loading="chequeSumReportDataLoading"
      :error-message="errorMessage"
  >
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";

export default {
  name: "MusteriSenetleri",
  components: {
    SimpleDataTable
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("auth",["user"])
  },
  mounted(){
    this._fetchChequeSumReport();
  },
  data(){
    return {
      chequeSumReportData: [],
      chequeSumReportHeaders: [],
      chequeSumReportDataLoading: false,
      errorMessage: "",
    }
  },
  methods: {
    ...mapActions("dashboard",["fetchBillSumReport"]),
    numberConverter,
    _fetchChequeSumReport(){
      this.fetchBillSumReport({
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          Type: 1
        }
      }).then(result => {
        if(result && result.data.success)
        {
          this.chequeSumReportHeaders = [
            {
              key: 'status',
              label: 'Tipi',
              sortable: false,
            },
            {
              key: 'amount',
              label: 'Tutar (TL)',
              sortable: false,
            },
          ];
          this.chequeSumReportData = result.data.data;
          this.chequeSumReportData.map((item) => {
            switch (item.status){
              case 1:
                item.status = "Portföydeki Senetler"
                break;
              case 2:
                item.status = "Tahsildeki Senetler"
                break;
              case 3:
                item.status = "Ciro Senetler"
                break;
              case 4:
                item.status = "Teminattaki Senetler"
                break;
              case 5:
                item.status = "İade Senetler"
                break;
              case 6:
                item.status = "Avukattaki Senetler"
                break;
            }
          })
          this.chequeSumReportData.map(item => item.amount = numberConverter(item.amount))
        } else {
          this.chequeSumReportData = [];
          this.errorMessage = result.data.message;

        }



      })
    }
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchChequeSumReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchChequeSumReport()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchChequeSumReport()
    }
  }
}
</script>

<style scoped>

</style>